<template>
  <div>
    <header-nav v-sticky-top="2"></header-nav>
    <router-view />
    <footer-box></footer-box>
  </div>
</template>
<script>
import HeaderNav from "@/components/headerNav/index.vue";
import FooterBox from "@/components/footerBox/index.vue";
export default {
  name: "LayoutPage",
  components: {
    HeaderNav,
    FooterBox,
  },
  data() {
    return {};
  },
  directives: {
    "sticky-top": {
      inserted(el, binding) {
        const threshold = binding.value || 0;
        let isFixed = false;
        let placeholder = null;

        // 创建占位元素
        placeholder = document.createElement("div");
        placeholder.style.display = "none";
        el.parentNode.insertBefore(placeholder, el);

        const checkScroll = () => {
          const elementTop = el.getBoundingClientRect().top + window.scrollY;
          const scrollY = window.scrollY;
          const shouldFix = scrollY >= elementTop - threshold;

          if (shouldFix && !isFixed) {
            el.classList.add("sticky-fixed");
            placeholder.style.display = "block";
            placeholder.style.height = el.offsetHeight + "px";
            isFixed = true;
          } else if (!shouldFix && isFixed) {
            el.classList.remove("sticky-fixed");
            placeholder.style.display = "none";
            isFixed = false;
          }
        };

        // 使用 requestAnimationFrame 节流
        const throttleCheck = () => {
          window.requestAnimationFrame(checkScroll);
        };

        window.addEventListener("scroll", throttleCheck);
        checkScroll(); // 初始检查

        // 保存引用以便卸载
        el._stickyScrollHandler = throttleCheck;
        el._stickyPlaceholder = placeholder;
      },
      unbind(el) {
        window.removeEventListener("scroll", el._stickyScrollHandler);
        if (el._stickyPlaceholder && el._stickyPlaceholder.parentNode) {
          el._stickyPlaceholder.parentNode.removeChild(el._stickyPlaceholder);
        }
      },
    },
  },
};
</script>
<style lang="scss">
.sticky-fixed {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  z-index: 1000 !important;
}
</style>
